import React from 'react';
import { clearDemoSessionToken } from '../utils/demoSession';

// The one shared "this is disabled in demo mode" UI — used identically by Export,
// Upload, and Approve/Submit (see useDemoGuard) so a visitor sees the same message and
// the same way forward everywhere, instead of each screen inventing its own version.
export const DemoSignInModal: React.FC<{ open: boolean; onClose: () => void; feature?: string }> = ({
  open,
  onClose,
  feature = 'use this feature',
}) => {
  if (!open) return null;

  // Lands on Landing with the Request Access form already open — the button says "Sign
  // in / Request access" and a visitor clicking it from inside a blocked-feature prompt
  // is expressing intent to get real access, not just browsing to the homepage.
  const goToSignIn = () => {
    clearDemoSessionToken();
    window.location.href = '/?requestAccess=1';
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-[12px] shadow-xl max-w-sm w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-10 h-10 rounded-full bg-tint dark:bg-green-900/20 flex items-center justify-center mb-3">
          <svg className="w-5 h-5 text-accent dark:text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <rect x="5" y="11" width="14" height="9" rx="2" />
            <path strokeLinecap="round" d="M8 11V7a4 4 0 118 0v4" />
          </svg>
        </div>
        <h3 className="text-base font-semibold text-text dark:text-gray-100 mb-1">You're in demo mode</h3>
        <p className="text-sm text-muted dark:text-gray-400 mb-5">
          Sign in to {feature} with your own schedule.
        </p>
        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 text-sm font-medium text-muted dark:text-gray-400 bg-gray-50 dark:bg-gray-700 py-2.5 rounded-[8px] hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors tap"
          >
            Not now
          </button>
          <button
            onClick={goToSignIn}
            className="flex-1 text-sm font-semibold text-white bg-accent py-2.5 rounded-[8px] hover:bg-link transition-colors tap"
          >
            Sign in / Request access
          </button>
        </div>
      </div>
    </div>
  );
};
